import styled from 'styled-components';
import Edit from '@carvana/icons/Edit';

export const Content = styled.div`
  background: #fff;
  border: 1px solid ${props => props.theme.carvana.gray.light};
  border-radius: 0.3rem;
  position: relative;
  height: 14.25rem;
  text-align: left;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 5px;
  margin-bottom: 40px;
  margin-top: 40px;
  height: 100%;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 25px;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${props => props.theme.carvana.gray.light};
  align-items: center;
  justify-content: space-between;
`;

export const Grid = styled.div`
  padding-top: 10px;
  display: flex;
  flex-direction: column;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    flex-direction: row;
  }
`;

export const Col = styled.div`
  flex-basis: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    flex-basis: 50%;
  }
`;

export const TextBox = styled.div`
  // &:not(:last-of-type) {
  //   padding-bottom: 10px;
  //  }
`;

export const EditButton = styled.a`
  color: ${props => props.theme.carvana.blue.primary};
  text-decoration: none;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
`;

export const Row = styled.div`
  display: flex;
  padding-top: 1rem;
  padding-bottom: 1.5rem;
  flex-direction: row;
  place-content: end space-between;
`;

export const Label = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-weight: 700;
  padding: 7px 0 7px 0;
`;

export const Data = styled.div`
   padding-bottom: 15px;
`;

export const Details = styled.div`
  text-align: left;
  font-size: 18px;
  font-weight: 700;
  padding-top: 20px;
  padding-bottom: 20px;
  color: ${props => props.theme.carvana.blue.dark};  
`;

export const Pencil = styled(Edit)`
  color: ${props => props.theme.carvana.blue.primary};
  cursor: pointer;

  & > svg {
    height: 20px;
    width: 20px;
  }
`;

